// extracted by css-extract-rspack-plugin
export default {"cls1":"AppsMegaMenu-cls1_jwi","cls2":"AppsMegaMenu-cls2_dF1 AppsMegaMenu-cls1_jwi"};